module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog-form\" title=\"Add Image\" style=\"display: none;\">\r\n    <div class=\"add-asset-step-1 step-template\" style=\"margin-top: 10px;\">\r\n        <input type=\"file\" id=\"file-asset\" name=\"file-asset\" class=\"inputfile\" accept=\"image/*\" style=\"display: none;\">\r\n        <label id=\"file-asset-label\" for=\"file-asset\">Select</label>\r\n        <input type=\"text\" id=\"file-asset-name\" placeholder=\"Image Name\" disabled>\r\n        </input>  \r\n        <!--button class=\"close-icon-asset\" type=\"reset\"></button-->  \r\n        <span id=\"asset-error-msg\" class=\"error_message hide\"></span> \r\n    </div>\r\n    <div id=\"assetViewerContainer\">\r\n        <img id=\"assetViewer\" src=\"#\" alt=\"\" style=\"height: auto;max-width: 100%; max-height: 100%;\">\r\n    </div>\r\n</div>")
  }
  return __output;

}